export default "__VITE_ASSET__nZNxkmHp__"